<template>
  <a-layout class="layout-container">
    <v-sider></v-sider>
    <a-layout>
      <v-header></v-header>
      <v-title></v-title>
      <a-layout-content class="layout-content">
        <router-view></router-view>
      </a-layout-content>
      <a-layout-footer class="layout-footer">
        Hotone Audio ©2019 Created by Hotone Software & Algorithm Department
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>

<script>
import Sider from './LayoutSider'
import Header from './LayoutHeader'
import Title from './LayoutTitle'

export default {
  name: 'Layout',

  components: {
    'v-sider': Sider,
    'v-header': Header,
    'v-title': Title
  }
}
</script>

<style lang="scss" scoped>
.layout-container {
  min-height: 100vh;

  .layout-content {
    margin: 24px 24px 0;
    padding: 24px;
    background: #fff;
    min-height: 280px;
  }

  .layout-footer {
    text-align: center;
  }
}
</style>
